import React from "react";
import { Box } from "@mui/material";

interface TimeoutsLeftIndicatorProps {
  timeoutsLeft: number;
  maxTimeouts?: number;
  size?: number;
}

export const TimeoutsLeftIndicator: React.FC<TimeoutsLeftIndicatorProps> = ({
  timeoutsLeft,
  maxTimeouts = 3,
  size = 10,
}) => {
  // Clamp value
  const normalizedTimeoutsLeft = Math.max(0, Math.min(timeoutsLeft, maxTimeouts));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
      {[...Array(maxTimeouts)].map((_, i) => (
        <Box
          key={i}
          sx={{
            width: size,
            height: size,
            borderRadius: "50%",
            bgcolor: i < normalizedTimeoutsLeft ? "warning.main" : "grey.800",
            border: `1px solid ${i < normalizedTimeoutsLeft ? '#FFD600' : '#444'}`,
            mb: i < maxTimeouts - 1 ? 0.5 : 0,
          }}
        />
      ))}
    </Box>
  );
}; 